import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { AttendanceMetricsProps } from './HistoryNotesPanel.props';

interface MetricItemProps {
  label: string;
  value: string;
}

const MetricItem: React.FC<MetricItemProps> = ({ label, value }) => (
  <Box
    sx={{
      flex: 1,
      textAlign: 'center',
      py: 1,
      px: 1.5,
      bgcolor: 'v4.tableEven',
      borderRadius: 1,
    }}
  >
    <Typography
      sx={{
        fontSize: '18px',
        fontWeight: 700,
        color: 'text.primary',
      }}
    >
      {value}
    </Typography>
    <Typography
      sx={{
        fontSize: '10px',
        fontWeight: 600,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}
    >
      {label}
    </Typography>
  </Box>
);

export const AttendanceMetrics: React.FC<AttendanceMetricsProps> = ({ metrics }) => (
  <Box sx={{ display: 'flex', gap: 1.5, mb: 1.5 }}>
    <MetricItem label="Total Visits" value={String(metrics?.totalVisits ?? 0)} />
    <MetricItem label="On-Site Time" value={metrics?.onSiteTime ?? '-'} />
    <MetricItem label="Avg Duration" value={metrics?.avgDuration ?? '-'} />
  </Box>
);
